import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";

export default function SectionGroup({ id, title, desc, defaultOpen = false, count, children }) {
  const [open, setOpen] = useState(() => {
    const s = localStorage.getItem(`health-group-${id}`);
    return s == null ? defaultOpen : s === "1";
  });
  const toggle = () =>
    setOpen((o) => {
      localStorage.setItem(`health-group-${id}`, o ? "0" : "1");
      return !o;
    });
  return (
    <div data-testid={`health-group-${id}`}>
      <button
        onClick={toggle}
        data-testid={`health-group-toggle-${id}`}
        className="w-full glass-card px-5 py-4 flex items-center gap-3 text-left"
      >
        <div className="flex-1 min-w-0">
          <div className="font-heading font-semibold">{title}</div>
          <div className="text-xs text-muted-foreground mt-0.5">{desc}</div>
        </div>
        {count != null && (
          <span className="text-[10px] num px-2 py-0.5 rounded-full bg-white/[0.06] border border-white/[0.08] text-muted-foreground shrink-0">
            {count}
          </span>
        )}
        <CaretDown size={16} className={`text-muted-foreground shrink-0 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <div className="space-y-6 mt-4 stagger">{children}</div>}
    </div>
  );
}
